<template>
	<div class="Shopbag">
		<div class="bag-nav">
			<van-nav-bar :fixed="true">
				<template #left>
					<div class="left-text">
						<div class="logo"><img class="auto-img" src="../assets/images/coffee_icon.jpg" alt=""></div>
						<div class="logo-title">Luckin Coffee</div>
					</div>
				</template>
				<template #right v-if="bagData.length > 0">
					<div class="bag-control" @click="editProduct">{{htmltext}}</div>
				</template>
			</van-nav-bar>
		</div>
		
		<div class="Empty">
			<van-empty description="你的购物袋有点寂寞" v-if="bagData.length <= 0" :image="carimgurls" >
			  <van-button round class="bottom-button" @click="goMenu">
				去喝一杯？
			  </van-button>
			</van-empty>
		</div>
		<div class="bag-product" v-for="(item,index) in bagData" :key="index">
			<van-swipe-cell :disabled="!isEdit" >
				<van-cell :border="false">
					<div class="clearfix">
						<div class="fl check">
							<van-checkbox v-model="item.isCheck" @change="simpleSelect" icon-size="24px"></van-checkbox>
						</div>
						<div class="fl pro-img">
							<img class="auto-img" :src="item.small_img" alt="">
						</div>
						<div class="fl pro-info">
							<div class="text-box">
								<div class="clearfix nameAndRule">
									<div class="fl text-name">{{item.name}}</div>
									<div class="fl text-rule">{{item.rule}}</div>
								</div>
								<div class="text-enname">{{item.enname}}</div>
							</div>
							<div class="price-box clearfix">
								<div class="price fl">￥{{item.price}}</div>
								<div class="fr">
									<van-stepper v-model="item.count" @change="changeCount(item)" theme="round" button-size="24" disable-input />
								</div>
							</div>
						</div>
					</div>
				</van-cell>
				 <template #right>
				    <van-button square text="删除" type="danger" class="delete-button" @click="delectOneShopbag(item.sid,index)" />
				  </template>
			</van-swipe-cell>
		</div>
		
		<!-- 底部栏 -->
		<div class="bag-footer" v-if="bagData.length > 0">
			<van-submit-bar v-show="!isEdit" :price="total" @submit="commit" button-text="提交订单">
			  <van-checkbox v-model="allCheck" @click="allSelect">全选</van-checkbox>
			</van-submit-bar>
			<van-submit-bar v-show="isEdit" @submit="delectMoreShopbag" button-text="删除选中">
			  <van-checkbox  @click="allSelect" v-model="allCheck">全选</van-checkbox>
			</van-submit-bar>
		</div>
		
	</div>
</template>

<script>
	import '../assets/less/shopbag.less'
	import {utils} from '../assets/js/utils'
	export default{
		data(){
			return{
				isEdit: false,
				allCheck: false,
				count: 1,
				htmltext: '管理',
				bagData:[],
				total: 0,
				carimgurls: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1597414311971&di=0574cea1cb991505620cbdb33327bc88&imgtype=0&src=http%3A%2F%2Fwww.51yuansu.com%2Fpic2%2Fcover%2F00%2F45%2F08%2F5814cf6eb5c10_610.jpg'
			}
		},
		
		created() {
			this.findShopbag();
		},
		
		methods:{
			//编辑商品
			editProduct(){
				this.isEdit = !this.isEdit;
				this.htmltext = this.isEdit ? '完成' : '管理';
			},
			
			//查询购物袋数据
			findShopbag(){
				let tokenString = localStorage.getItem('RETK');
				if(!tokenString){
					return;
				}
				
				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner'
				})
				
				this.axios({
					method: 'GET',
					url: '/findAllShopcart',
					params: {
						appkey: this.appkey,
						tokenString
					}
				}).then(result =>{
					this.$toast.clear();
					
					if(result.data.code == 5000){
						result.data.result.map( v=>{
							v.isCheck = false;
						})
						this.bagData = result.data.result;
					}else{
						this.$toast(result.data.msg)
					}
					
				}).catch(err =>{
					this.$toast.clear();
				})
			},
			
			//全选
			allSelect(){
				this.bagData.map(v =>{
					v.isCheck = this.allCheck;
				})
			},
			
			//单选
			simpleSelect(){
				
				this.sum();
				
				for(let i = 0; i < this.bagData.length; i++){
					if(!this.bagData[i].isCheck){
						console.log(this.bagData[i].isCheck);
						this.allCheck = false;
						return;
					}
				}
				this.allCheck = true;
			},
			
			//修改商品数量
			changeCount(item){
				let tokenString = localStorage.getItem('RETK');
				if(!tokenString){
					return;
				}
				
				//参数序列化
				let data = utils.queryString({
					appkey: this.appkey,
					tokenString,
					sid: item.sid,
					count: item.count
				})
				
				
				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner'
				})
				
				this.axios({
					method: 'POST',
					url: '/modifyShopcartCount',
					data
				}).then(result =>{
					this.$toast.clear();
					
					this.sum();
					if(result.data.code !== 6000){
						this.$toast(result.data.msg);
					}
				}).catch(err =>{
					this.$toast.clear();
				})
			},
			
			//删除购物袋数据
			delectBagData(sids){
				
				//sids: sid的集合, 类型: array
				
				let tokenString = localStorage.getItem('RETK');
				if(!tokenString){
					return;
				}
				
				//参数序列化
				let data = utils.queryString({
					appkey: this.appkey,
					tokenString,
					sids: JSON.stringify(sids),
				})
				
				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner'
				})
				
				return this.axios({
					method: 'POST',
					url: '/deleteShopcart',
					data
				})
			},
			
			//单个删除
			delectOneShopbag(sid, index){
				this.delectBagData([sid]).then(result =>{
					this.$toast.clear();
					if(result.data.code == 7000){
						this.bagData.splice(index, 1);
					}
						this.sum();
				}).catch(err =>{
					this.$toast.clear();
				})
			},
			
			//删除多个
			delectMoreShopbag(){
				//查找选择购物袋
				let sids = [];
				this.bagData.map( v=>{
					if(v.isCheck){
						sids.push(v.sid);
					}
				})
				
				this.delectBagData(sids).then(result =>{
					this.$toast.clear();
					if(result.data.code == 7000){
						for(let i = this.bagData.length -1; i>=0; i--){
							if(this.bagData[i].isCheck){
								this.bagData.splice(i, 1);
							}
						}
						this.sum();
					}
				}).catch(err =>{
					this.$toast.clear();
				})
			},
			
			//计算总金额
			sum(){
				this.total = 0;
				this.bagData.map(v =>{
					if(v.isCheck){
						this.total += v.count * v.price
					}
				})
				
				this.total *=100;
			},
			
			//前往菜单
			goMenu(){
				this.$router.push('Menu');
			},
			
			//提交商品
			commit(){
				
				//查询需要购买的商品，sid
				let sids = [];
				this.bagData.map(v =>{
					if(v.isCheck){
						sids.push(v.sid);
					}
				})
				
				sids = sids.join('-');
				
				if(sids.length <= 0){
					this.$toast('你还没有选中商品哦');
					return
				}
				
				this.$router.push({name: 'Order', query: {sids}});
				
			}
		}
		
	}
</script>

<style lang="less" scoped>
	 .goods-card {
	    margin: 0;
	    background-color: white;
	  }
	
	  .delete-button {
	    height: 100%;
	  }
	  
	  .bottom-button {
	      width: 160px;
	      height: 40px;
		  background: transparentz;
		  color: #212572;
		  border: 0;
	  }
</style>